/* global $ */

import { getButton } from '../helpers/sliderHelpers';

const $sliderRow = $('.slider-row .row');

const sliderRowInst = {
  initialize(el) {
    this.el = el;
    this.$el = $(el);
    this.numberOfSlides = this.$el.children().length;

    this.createListeners();
    this.create();
  },

  /**
   * Create event listeners
   *
   * @return {void}
   */
  createListeners() {
    //
  },

  /**
   * Calculate dimensions
   *
   * @return {void}
   */
  calcDimensions() {
    //
  },

  /**
   * Create slider
   *
   * @return {void}
   */
  create() {
    this.$el.slick(Object.assign(this.getResponsiveConfig(), {
      arrows: true,
      prevArrow: getButton('Vorige', 'slider__arrow slick-prev', 'arrow-large-left'),
      nextArrow: getButton('Volgende', 'slider__arrow slick-next', 'arrow-large-right'),
    }));
  },

  getResponsiveConfig() {
    const cols = typeof this.$el.data('columns') !== 'undefined' ? this.$el.data('columns') : 3;

    if (cols === 3) {
      return {
        slidesToShow: 3,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      };
    }

    return {
      slidesToShow: 4,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
          },
        },
      ],
    };
  },
};

export default {
  initialize() {
    $sliderRow.each((i, el) => {
      const inst = { ...sliderRowInst };
      inst.initialize(el);
    });
  },
};
